define('controllers/news',['require','johngrid'],function(require) {
	var CreateJohnGrid = require('johngrid');
	return function() {
		$(function () {
			var grid = CreateJohnGrid(),
				tblNews = $("#tblNews"),
				columns = [{ DataField: "Title" },
							{ DataField: "StartDate", HeaderText: "Starts" },
							{ DataField: "EndDate", HeaderText: "Ends" },
							{ DataField: "CreateDate", HeaderText: "Created" },
							{ DataField: "Private" }],
				editTemplate = $("#editTemplate"),
				filterHead = $("#filterHead"),
				txtDescriptionHTMLID = "txtDescriptionHTML",
				txtDescriptionHTML = new nicEditor({ fullPanel: true }).panelInstance(txtDescriptionHTMLID, { hasPanel: true }),
				btnAddRelationShip = $("#btnAddRelationShip");

			grid.onDataBinding = function () {
				var filterHead = $("#filterHead");
				grid.dsPostValues.Search = $("#txtSearch", filterHead).val();
				grid.dsPostValues.FilterHotel = $(".txtSearchHotels", filterHead).attr("data-selectedvalue");
				grid.dsPostValues.FilterRegion = $(".txtSearchDestinations", filterHead).attr("data-selectedvalue");
			};
			grid.insertHelpers.onAdd = function () {
				SetRelationships([], []);
				txtDescriptionHTML.instanceById(txtDescriptionHTMLID).setContent("");
			};
			grid.editHelpers.onEdit = function (item) {
				SetRelationships(item.HotelIds, item.RegionIds);
				txtDescriptionHTML.instanceById(txtDescriptionHTMLID).setContent(item.DescriptionHTML);
			};
			grid.utilities.validateItem = function (item) {
				var errors = [],
					currentRelationships = GetRelationships(),
					StartDate = Date.parse(item.StartDate),
					EndDate = Date.parse(item.EndDate);

				if (item.Title == "") errors.push("Please enter a title.");
				if (item.DescriptionHTML == "") errors.push("Please enter Description HTML for the news item.");
				if (isNaN(StartDate) || isNaN(EndDate) || EndDate < StartDate) errors.push("Please enter valid Start And End dates.");
				if (isNaN(item.SortOrder) || item.SortOrder == "") errors.push("Please enter a number for Sort Order.");

				item.DescriptionHTML = Utilities.htmlEncode(txtDescriptionHTML.instanceById(txtDescriptionHTMLID).getContent());
				item.HotelIds = currentRelationships.HotelIds.join(",");
				item.RegionIds = currentRelationships.RegionIds.join(",");

				return errors;
			};

			function SetRelationships(hotelIds, regionIds) {
				var txtSearchHotels = $("#AddRelationships .txtSearchHotels"),
					txtSearchDestinations = $("#AddRelationships .txtSearchDestinations"),
					hotels = txtSearchHotels.autocomplete("option", "source"),
					regions = txtSearchDestinations.autocomplete("option", "source"),
					hotelRelationships = [],
					regionRelationships = [],
					Dest_Relationships = $("#Dest_Relationships"),
					Hotel_Relationships = $("#Hotel_Relationships"),
					relationshipTemplate = "<div data-value='{0}'><i title='Remove Relationship' class='icon-trash'></i> {1}</div>";

				//empty search boxes
				txtSearchHotels.val("").attr("data-selectedValue", 0);
				txtSearchDestinations.val("").attr("data-selectedValue", 0);

				//display selected hotels
				for (var i = 0; i < hotelIds.length; i++) {
					var hotelId = hotelIds[i];
					for (var j = 0; j < hotels.length; j++) {
						var searchHotel = hotels[j];
						if (searchHotel.value == hotelId) {
							hotelRelationships.push(relationshipTemplate.format(searchHotel.value, searchHotel.label));
							break;
						}
					}
				}
				Hotel_Relationships.html(hotelRelationships.join(""));

				//display selected destinations
				for (var i = 0; i < regionIds.length; i++) {
					var regionId = regionIds[i];
					for (var j = 0; j < regions.length; j++) {
						var searchRegion = regions[j];
						if (searchRegion.value == regionId) {
							regionRelationships.push(relationshipTemplate.format(searchRegion.value, searchRegion.label));
							break;
						}
					}
				}
				Dest_Relationships.html(regionRelationships.join(""));

				//set up handler for remove click
				$(".icon-trash", Hotel_Relationships.parent()).off("click").on("click", function () {
					$(this).parent().remove();
				});
			}
			function GetRelationships() {
				var Relationships = { HotelIds: [], RegionIds: [] };

				$("#Dest_Relationships div[data-value]").each(function (index, value) {
					Relationships.RegionIds.push($(this).attr("data-value"));
				});

				$("#Hotel_Relationships div[data-value]").each(function (index, value) {
					Relationships.HotelIds.push($(this).attr("data-value"));
				});

				return Relationships;
			}

			grid.insertHelpers.init(editTemplate);
			grid.editHelpers.init(editTemplate);
			grid.sorting.allowSorting = true;
			grid.dsPostValues.sortClause = "CreateDate DESC";
			grid.init(tblNews, columns, "News_Ajax.aspx");
			$(".johnGridHeader", grid.$table).prepend(filterHead);
			grid.databind();

			btnAddRelationShip.on("click", function () {
				var newHotelId = $("#AddRelationships .txtSearchHotels").attr("data-selectedvalue"),
					newRegionId = $("#AddRelationships .txtSearchDestinations").attr("data-selectedvalue"),
					currentRelationships = GetRelationships();

				if ($.inArray(newHotelId, currentRelationships.HotelIds) == -1) currentRelationships.HotelIds.push(newHotelId);
				if ($.inArray(newRegionId, currentRelationships.RegionIds) == -1) currentRelationships.RegionIds.push(newRegionId);
				SetRelationships(currentRelationships.HotelIds, currentRelationships.RegionIds); //simply reset all, since there will never be many...
			});

			$(".datepicker").datepicker();

			Utilities.setDefaultButton(filterHead, $(".btnRefresh", grid.$table));
			Utilities.setDefaultButton($("#AddRelationships"), btnAddRelationShip);
		});
	};
});
